export const TYPE_LABEL_MAP = {
  click: '点击推事件',
  view: '链接',
  miniprogram: '跳转小程序'
}

export const BUTTON_DEFAULTS = {
  name: '新菜单',
  type: 'view',
  sub_button: [],
  url: '',
  key: '',
  appid: '',
  pagepath: ''
}

let uidCounter = 0

export function nextUid() {
  uidCounter += 1
  return `menu-btn-${uidCounter}`
}

export function buildKeysMap(clickButtons) {
  const map = {}
  ;(clickButtons || []).forEach(({ key, label }) => {
    map[key] = label
  })
  return map
}

export function parseButton(raw, { clickButtons }) {
  const button = { ...BUTTON_DEFAULTS, ...raw }
  const subButtons = button.sub_button || []
  button.sub_button = subButtons.map((child) =>
    parseButton(child, { clickButtons })
  )
  button.typeLabel = TYPE_LABEL_MAP[button.type] || TYPE_LABEL_MAP.view
  if (button.type === 'click') {
    const keysMap = buildKeysMap(clickButtons)
    button.keyLabel = keysMap[button.key]
  }
  button._uid = button._uid || nextUid()
  return button
}

export function parseButtons(payload, options) {
  const buttons = (payload && payload.button) || []
  return buttons.map((b) => parseButton(b, options))
}

export function cloneButtonState(button) {
  return JSON.parse(JSON.stringify(button))
}

export function serializeButton(button) {
  const json = cloneButtonState(button)
  delete json._uid
  delete json.typeLabel
  delete json.keyLabel
  delete json.originButton

  const subButtons = json.sub_button || []
  if (subButtons.length === 0) {
    switch (json.type) {
      case 'view':
        delete json.key
        delete json.appid
        delete json.pagepath
        break
      case 'click':
        delete json.appid
        delete json.pagepath
        delete json.url
        break
      case 'miniprogram':
        delete json.key
        break
      default:
        break
    }
    delete json.sub_button
  } else {
    delete json.type
    delete json.key
    delete json.url
    delete json.appid
    delete json.pagepath
    json.sub_button = subButtons.map(serializeButton)
  }

  return json
}

export function serializeButtons(buttons) {
  return buttons.map(serializeButton)
}

export function changeButtonType(button, type, clickButtons) {
  const updated = { ...button, type, typeLabel: TYPE_LABEL_MAP[type] }
  if (type === 'click' && clickButtons && clickButtons.length) {
    updated.key = clickButtons[0].key
    updated.keyLabel = clickButtons[0].label
  }
  return updated
}

export function changeButtonKey(button, key, clickButtons) {
  const keysMap = buildKeysMap(clickButtons)
  return {
    ...button,
    key,
    keyLabel: keysMap[key] || '自定义'
  }
}

export function stringByteLength(str) {
  return (str || '').replace(/[^\x00-\xff]/g, 'xx').length
}

export function validateNameLength(name, { isRoot, limits }) {
  const maxLength = isRoot ? limits.max_menu_name_length : limits.max_submenu_name_length
  if (!maxLength) {
    return true
  }
  return stringByteLength(name) <= maxLength
}

export function createEmptyButton(name = '新菜单', options = { hasSyncButton: true, clickButtons: [] }) {
  return parseButton({ name }, options)
}

export function createEmptySubButton(options = { hasSyncButton: true, clickButtons: [] }) {
  return parseButton({ name: '新子菜单' }, options)
}
